<template>
  <article
    class="post_short"
    :style="{ backgroundColor: backgroundColor }"
    @click="openPost(post.id)"
  >
    <div class="post_short_header">
      <div
        class="short_remake_avatar_box"
        v-if="ancestorsCounts"
        @click.stop="openRemakesFeed(post)"
      >
        <Avatar
          :user="post.user"
          class="short_remake_avatar"
          :style="{ borderColor: backgroundColor }"
        />

        <div
          v-if="ancestorsCounts > 1"
          class="short_remake_avatar_count short_remake_avatar"
          :style="{ borderColor: backgroundColor }"
        >
          <p>{{ ancestorsCounts }}</p>
        </div>

        <Avatar
          v-if="post?.original_post?.user"
          :user="post?.original_post?.user"
          class="short_remake_avatar"
          :style="{ borderColor: backgroundColor }"
        />
      </div>
      <Avatar
        v-else
        :user="post.user"
        class="short_avatar"
        @click.stop="openProfile(post.user.id)"
      />

      <RemakeBtn :post="post" class="short_remake_btn" />
    </div>

    <PostShortSlider
      :post="post"
      :visible="isVisible"
      class="post_short_slider"
    />
  </article>
</template>

<script>
import PostShortSlider from "./PostShortSlider.vue";
import Avatar from "@/components/Avatar.vue";
import RemakeBtn from "@/UI/Button/RemakeBtn.vue";
import { useModalStore } from "@/stores/modalStore";
import { useOpenPost } from "../../composables/useOpenPost.js";
import { useOpenProfile } from "../../composables/useOpenProfile.js";
import { useOpenRemakesFeed } from "../../composables/useOpenRemakesFeed.js";

export default {
  name: "PostShort",
  components: {
    PostShortSlider,
    Avatar,
    RemakeBtn,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openPost: null,
      observer: null,
      isVisible: false,
      openProfile: useOpenProfile().openProfile,
      openRemakesFeed: useOpenRemakesFeed().openRemakesFeed,
      backgroundColor: this.post?.metadata?.background_color || "#ffffff60",
      ancestorsCounts: this.post.all_ancestors.length,
      modal: useModalStore(),
    };
  },
  mounted() {
    this.openPost = useOpenPost([this.post]).openPost;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    this.observer.observe(this.$el);
  },
};
</script>

<style>
.post_short {
  cursor: pointer;
  height: 300px;
  border-radius: 31px;
  overflow: hidden;
  margin-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  z-index: 5;
  padding: 12px 0px 12px 12px;
}

.short_remake_avatar_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 60%;
  position: relative;
}

.short_avatar,
.short_remake_avatar {
  box-sizing: border-box;
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.post_description {
  font-size: 16px;
  font-weight: 700;
  padding-left: 50px;
  display: flex;
  position: relative;
}

.bubble {
  margin: 0;
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 16px;
  max-width: 100%;
  color: black;
  font-size: 15px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.short_remake_avatar {
  border: 2px solid;
}

.short_remake_avatar:nth-child(1) {
  top: 0;
  left: 0;
  z-index: 3;
}

/* счетчик */
.short_remake_avatar_count {
  display: flex;
  align-items: center;
  color: black;
  justify-content: center;
  background: white;
  box-sizing: border-box;
  border: 2px solid;
  font-size: 16px;
  text-align: center;
  font-weight: bolder;
}

.short_remake_avatar:nth-child(2) {
  position: absolute;
  top: 30px;
  left: 0;
  z-index: 2;
}

/* третья */
.short_remake_avatar:nth-child(3) {
  position: absolute;
  top: 55px;
  z-index: 1;
}

.post_short_header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 45px;
}

.post_short_slider {
  width: 200px;
  margin-left: 10px;
}

.short_remake_btn {
  gap: 3px;
  padding: 2px 5px;
  height: auto;
}

.short_remake_btn::before {
  background: none;
}
</style>
